import React, { useMemo } from "react";

import Qs from "qs";
import { useTranslation } from "react-i18next";

import { Modal, Typography } from "antd";

import { Deeplink } from "../../../store/common_types";

export interface DeeplinkModalProps {
  deeplink?: Deeplink;
  visible?: boolean;
  onClose?: () => void;
}

const { Title, Paragraph } = Typography;

export const DeeplinkModal: React.FC<DeeplinkModalProps> = (props) => {
  const { t } = useTranslation("deeplink_modal");

  const payload = useMemo(() => {
    if (props.deeplink && props.deeplink.params) {
      return JSON.stringify(props.deeplink?.params, null, 4);
    }
    if (props.deeplink && props.deeplink.url) {
      const url = new URL(props.deeplink.url);
      const qs = Qs.parse(url.searchParams.toString());
      return JSON.stringify(qs, null, 4);
    }
    return null;
  }, [props.deeplink]);

  return (
    <Modal visible={props.visible} width="600px" title={t("title")} onCancel={props.onClose} footer={[]}>
      <Title level={5} copyable={{ text: props.deeplink?.url }}>
        URL
      </Title>
      <Paragraph>
        <pre style={{ wordBreak: "break-all" }}>{props.deeplink?.url}</pre>
      </Paragraph>
      {payload && (
        <>
          <Title level={5} copyable={{ text: payload }}>
            {t("parameters")}
          </Title>
          <Paragraph>
            <pre style={{ wordBreak: "break-all" }}>{payload}</pre>
          </Paragraph>
        </>
      )}
    </Modal>
  );
};
